import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/map';

@Injectable()
export class ModuleService {
    constructor (private authHttp: AuthHttp){}

    getAllModules(){
        return this.authHttp.get('/api/modules/').map(res => res.json());
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/modules.service.ts